var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 234 234",
    style: {
      enableBackground: "new 0 0 234 234"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#E2E2E2;stroke-miterlimit:10;}\n\t.st1{fill:#DEDEDE;}\n\t.st2{fill:#1E4480;}\n\t.st3{fill:#152E51;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 117,
    cy: 117,
    r: 116.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.1,99.6c0,17.1-6.4,33.7-17.9,46.4s-27.3,20.7-44.4,22.4c0.8-9.8-2.2-19.6-8.5-27.2s-15.2-12.5-25-13.7 V35.9c10.5-4.4,21.9-6.2,33.3-5.1c11.3,1.1,22.2,4.9,31.7,11.2s17.3,14.9,22.6,24.9C183.3,77,186.1,88.2,186.1,99.6L186.1,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.2,169.6c-0.7-5.8,0-11.6,2-17.1s5.1-10.4,9.3-14.5c6.3,9.5,14.9,17.2,24.9,22.6s21.3,8.1,32.6,8.1 c2.3,0,4.5-0.1,6.8-0.3c-0.8,9.4-5,18.2-11.9,24.7c-6.9,6.5-15.9,10.1-25.4,10.3c-9.4,0.1-18.6-3.2-25.7-9.5 C53.8,187.6,49.3,179,48.2,169.6L48.2,169.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.3,36v91.5c9.8,1.1,18.8,6,25,13.7c6.3,7.6,9.3,17.4,8.5,27.2c-2.2,0.2-4.5,0.3-6.8,0.3 c-11.4,0-22.6-2.8-32.6-8.1c-10-5.4-18.6-13.1-24.9-22.6c6-5.8,13.8-9.5,22.1-10.4l0,0V40.3C84.3,38.7,87.2,37.2,90.3,36L90.3,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,99.6c0-12,3.1-23.7,9-34.1s14.4-19.1,24.7-25.2v87.2c-8.3,0.9-16.1,4.6-22.2,10.5 C51.9,126.6,47.9,113.3,48,99.6L48,99.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendleIcon);
export default __webpack_public_path__ + "static/media/pendle_icon.e7c3ef5c77da32d3df623220aae87c8c.svg";
export { ForwardRef as ReactComponent };